<script setup lang="ts">
import type { LabelledSection } from '@@/types'
import SurfacePostGroupHeaderSectionOld from '@@/vuecomponents/SurfacePostGroupHeaderSectionOld.vue'

defineProps<{
  section: Required<LabelledSection>
}>()
</script>

<template>
  <SurfacePostGroupHeaderSectionOld :section="section" :hide-buttons="true" style="transform: rotate(-2deg)" />
</template>
